import { useEffect, useState } from "react";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import CustomLoader from "../static/CustomLoader";

const Question = ({
  selectedId,
  mode,
  onHide,
  setRefresh,
  chapterData,
  parentData,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState(0);
  const [code, setCode] = useState(0);
  const [question, setQuestion] = useState("");
  const [chaptercode, setChapterCode] = useState(0);
  const [parent, setParent] = useState(0);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  useEffect(() => {
    if (mode === "U") {
      const fetchQuestionData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${apiUrl}question/id/${selectedId}`,
            { headers },
          );
          const data = response.data;
          if (data.cd === 1) {
            toast.info(data.description);
          } else {
            setId(data.id);
            setCode(data.code);
            setQuestion(data.question);
            setChapterCode(data.chaptercode);
            setParent(data.parent);
          }
        } catch (error) {
          toast.error("Failed to fetch details.");
        } finally {
          setLoading(false);
        }
      };

      fetchQuestionData();
    }
  }, [mode]);

  function clearFields() {
    setId(0);
    setCode(0);
    setQuestion("");
    setChapterCode(0);
    setParent(0);
  }

  const handleFocus = (field) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  const validateFields = () => {
    let errors = {};
    if (!question) errors.question = "Question is required...";
    if (!chaptercode) errors.chaptercode = "Chapter is required...";
    if (parseInt(chaptercode) === 1 && question)
      errors.chaptercode = "General chapter cannot have questions...";
    return errors;
  };

  const handleAdd = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}question`,
        {
          question,
          chaptercode,
          parent,
        },
        { headers },
      );

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
      }
      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while adding data.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `${apiUrl}question/${selectedId}`,
        {
          id,
          code,
          question,
          chaptercode,
          parent,
        },
        { headers },
      );

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
      }
      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while updating data.");
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const handlesubmit = async () => {
    setLoading(true);

    const fieldErrors = validateFields();
    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    }

    if (mode === "A") {
      await handleAdd();
    } else {
      await handleUpdate();
    }
  };

  if (mode === "A") {
    /*Handle Update */
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />

        <div className="popupmodal-maindiv">
          <form>
            <FormGroup>
              <Label for="question">Question</Label>
              <input
                type="text"
                className={`form-control ${
                  errors.question ? "is-invalid" : ""
                }`}
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                onFocus={() => handleFocus("question")}
                placeholder="Enter Question"
              />
              {errors.question && (
                <div className="invalid-feedback">{errors.question}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="chapter">Chapter</Label>
              <Select
                options={chapterData}
                isClearable
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={
                  chaptercode
                    ? chapterData.find(
                        (option) => option.value === chaptercode,
                      ) || null
                    : null
                }
                onChange={(selected) => setChapterCode(selected?.value || "")}
                onFocus={() => handleFocus("chaptercode")}
                placeholder="Select Chapter"
              />
              {errors.chaptercode && (
                <div className="text-danger">{errors.chaptercode}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="parent">Parent</Label>
              <Select
                options={parentData}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                isClearable
                value={
                  parent
                    ? parentData.find((option) => option.value === parent) ||
                      null
                    : null
                }
                onChange={(selected) => setParent(selected?.value || "")}
                placeholder="Select Parent (Optional)"
              />
            </FormGroup>
          </form>
          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
          {loading && <CustomLoader />}
        </div>
      </>
    );
  } else if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <form>
            <FormGroup>
              <Label for="question">Question</Label>
              <input
                type="text"
                className={`form-control ${
                  errors.question ? "is-invalid" : ""
                }`}
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                onFocus={() => handleFocus("question")}
                placeholder="Enter Question"
              />
              {errors.question && (
                <div className="invalid-feedback">{errors.question}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="chapter">Chapter</Label>
              <Select
                options={chapterData}
                isClearable
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={
                  chaptercode
                    ? chapterData.find(
                        (option) => option.value === chaptercode,
                      ) || null
                    : null
                }
                onChange={(selected) => setChapterCode(selected?.value || "")}
                onFocus={() => handleFocus("chaptercode")}
                placeholder="Select Chapter"
              />
              {errors.chaptercode && (
                <div className="text-danger">{errors.chaptercode}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="parent">Parent</Label>
              <Select
                options={parentData}
                isClearable
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={
                  parent
                    ? parentData.find((option) => option.value === parent) ||
                      null
                    : null
                }
                onChange={(selected) => setParent(selected?.value || "")}
                placeholder="Select Parent (Optional)"
              />
            </FormGroup>
          </form>
          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
          {loading && <CustomLoader />}
        </div>
      </>
    );
  }
};

export default Question;
